import React from "react";

const FTFRAreas = ({ title, areas }) => {
  return (
    <section className="ftfr-areas-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
        </div>

        <div className="row g-4">
          {areas.map((area, i) => (
            <div
              key={i}
              className="col-md-6 col-lg-4"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="ftfr-area-card">
                <p className="ftfr-area-title">{area.title}</p>
                <p className="ftfr-area-desc">{area.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FTFRAreas;
